import { useClassStore } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { action } from 'mobx';

import container from '../../ioc/ioc';

import ExternalLinkService from '~gateways/external-link';
import AccountManagementStore from '~stores/account-management';
import AuthStore from '~stores/authentication';
import CheckoutStore from '~stores/checkout';
import ProductsStore from '~stores/products';
import SupportStore from '~stores/support';

@injectable()
export class SideNavPresenter {
  @inject(AccountManagementStore)
  private AccountManagementStore!: AccountManagementStore;
  @inject(AuthStore)
  private AuthStore!: AuthStore;
  @inject(ProductsStore)
  private ProductsStore!: ProductsStore;
  @inject(CheckoutStore)
  private CheckoutStore!: CheckoutStore;
  @inject(SupportStore)
  private SupportStore!: SupportStore;

  @action
  handleQuickTipsPress = (
    newState: boolean = !this.ProductsStore.uiQuickTipsPanelOpen
  ) => {
    this.ProductsStore.uiQuickTipsPanelOpen = newState;
  };

  @action handleAboutClick = () => {
    this.ProductsStore.uiAboutPanelOpen = !this.ProductsStore.uiAboutPanelOpen;
  };

  @action handleUserAccountClick = async () => {
    this.CheckoutStore.checkBuyFlow().then();

    this.AccountManagementStore.uiAccountManagementPanelOpen = true;
  };

  toggleSupport = () => {
    if (!this.AuthStore.currentUser) {
      ExternalLinkService.openUrl('mailto:support@toscan.eu', '_self');
    } else {
      this.SupportStore.uiSupportPanelOpen =
        !this.SupportStore.uiSupportPanelOpen;
    }
  };
}

const useSideNavPresenter = () =>
  useClassStore<SideNavPresenter>(container.get(SideNavPresenter));

export default useSideNavPresenter;
